<section class="acesso-rapido" aria-label="Acesso rápido">
  <div class="acesso-rapido-grade">
    @for (item of itens; track item.id) {
      <a class="acesso-rapido-card" [routerLink]="item.link">

        <span class="acesso-rapido-decor" aria-hidden="true">
          <span
            class="acesso-rapido-decor-dot acesso-rapido-decor-dot-topo"
            [style.background]="item.decor.corTopo"
          ></span>

          <span
            class="acesso-rapido-decor-dot acesso-rapido-decor-dot-base"
            [style.background]="item.decor.corBase"
          ></span>

          <span
            class="acesso-rapido-decor-triangulo"
            [style.border-bottom-color]="item.decor.corTriangulo"
          ></span>
        </span>

        <img
          class="acesso-rapido-icone"
          [ngSrc]="item.icone"
          width="84"
          height="84"
          alt=""
        />

        <span class="acesso-rapido-label">{{ item.label }}</span>

        <img class="acesso-rapido-underline" [src]="item.linha" alt="" aria-hidden="true" />
      </a>
    }
  </div>
</section>
